module.exports = __webpack_public_path__ + "static/media/sun.922f1f6e.svg";